module.exports = __webpack_public_path__ + "img/tutorial_001.45e1ef27.png";